import { requestToken, requestTokenImage } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/game-manage`;

class GameServices {
  /**
   * Active games, readable by any signed-in role. This is the list every
   * screen builds its game tabs and dropdowns from - it replaces the
   * hardcoded 3min / 5min pair.
   */
  async getActiveGames() {
    try {
      return await requestToken.get(`${API_ROUTE}/active`);
    } catch (error) {
      console.error("Error in getActiveGames:", error);
      throw error;
    }
  }

  /** Durations, ghar range, active-game cap, and the global yantra list. */
  /** The reveal animations a game can be set to play. */
  async getWinnerAnimations() {
    try {
      return await requestToken.get(`${API_ROUTE}/winner-animations`);
    } catch (error) {
      console.error("Error in getWinnerAnimations:", error);
      throw error;
    }
  }

  async getOptions() {
    try {
      return await requestToken.get(`${API_ROUTE}/options`);
    } catch (error) {
      console.error("Error in getOptions:", error);
      throw error;
    }
  }

  async getGames() {
    try {
      return await requestToken.get(`${API_ROUTE}/list`);
    } catch (error) {
      console.error("Error in getGames:", error);
      throw error;
    }
  }

  /** One game plus its board, with names and images already resolved. */
  async getBoard(gameId) {
    try {
      return await requestToken.get(`${API_ROUTE}/board/${gameId}`);
    } catch (error) {
      console.error("Error in getBoard:", error);
      throw error;
    }
  }

  async createGame(payload) {
    try {
      return await requestToken.post(`${API_ROUTE}/create`, payload);
    } catch (error) {
      console.error("Error in createGame:", error);
      throw error;
    }
  }

  async updateGame(payload) {
    try {
      return await requestToken.post(`${API_ROUTE}/update`, payload);
    } catch (error) {
      console.error("Error in updateGame:", error);
      throw error;
    }
  }

  async toggleActive(id, isActive) {
    try {
      return await requestToken.post(`${API_ROUTE}/toggle-active`, {
        id,
        is_active: isActive ? 1 : 0,
      });
    } catch (error) {
      console.error("Error in toggleActive:", error);
      throw error;
    }
  }

  async deleteGame(id) {
    try {
      return await requestToken.post(`${API_ROUTE}/delete`, { id });
    } catch (error) {
      console.error("Error in deleteGame:", error);
      throw error;
    }
  }

  /** payload must be FormData - slots carry images. */
  async saveBoard(gameId, payload) {
    try {
      return await requestTokenImage.post(`${API_ROUTE}/board/${gameId}`, payload);
    } catch (error) {
      console.error("Error in saveBoard:", error);
      throw error;
    }
  }
}

export default GameServices;
